import {Route, Routes} from "react-router-dom";
import {Settlements} from "../Settlements/Settlements";
import {Companies} from "../Companies/Companies";
import {ReportSelector} from "../Reports/ReportSelector";
import {ReportS1} from "../Reports/ReportS1";
import {ReportS2} from "../Reports/ReportS2";
import {ReportS3} from "../Reports/ReportS3";
import {ReportS4} from "../Reports/ReportS4";
import {ReportS5, ReportS5Municipality} from "../Reports/ReportS5";
import {ReportS4General, ReportS4GeneralMunicipality} from "../Reports/ReportS4General";
import {ReportS8, ReportS8Municipality} from "../Reports/ReportS8";
import {ReportControl} from "../Reports/ReportControl";
import {ReportCross} from "../Reports/ReportCross";
import {ReportProtocols} from "../Reports/ReportProtocols";
import {ReportCrops} from "../Reports/ReportCrops";
import {ReportS12} from "../Reports/ReportS12";
import {ReportS13} from "../Reports/ReportS13";
import {ReportS14} from "../Reports/ReportS14";

export const Year = () => {
    return (
        <div>
            <Routes>
                <Route path="/settlements/*" element={<Settlements/>}/>
                <Route path="/companies/*" element={<Companies/>}/>
                <Route path="/reports" element={<ReportSelector/>}/>
                <Route path="/reports/s1/:settlement_ekatte" element={<ReportS1/>}/>
                <Route path="/reports/s2/:bullstat" element={<ReportS2/>}/>
                <Route path="/reports/s3/:bullstat" element={<ReportS3/>}/>
                <Route path="/reports/s4/:bullstat1/:bullstat2" element={<ReportS4/>}/>
                <Route path="/reports/s5/:settlement_ekatte/:bullstat" element={<ReportS5/>}/>
                <Route path="/reports/s4general/:settlement_ekatte/:bullstat" element={<ReportS4General/>}/>
                {/* Ъ16: С3/С4 за цяла община. */}
                <Route path="/reports/s5/municipality/:municipality/:bullstat" element={<ReportS5Municipality/>}/>
                <Route path="/reports/s4general/municipality/:municipality/:bullstat"
                       element={<ReportS4GeneralMunicipality/>}/>
                <Route path="/reports/s8/:settlement_ekatte/:bullstat" element={<ReportS8/>}/>
                <Route path="/reports/s8/municipality/:municipality/:bullstat" element={<ReportS8Municipality/>}/>
                <Route path="/reports/control/:settlement_ekatte" element={<ReportControl/>}/>
                <Route path="/reports/cross/:scopeType/:scope" element={<ReportCross/>}/>
                <Route path="/reports/protocols/:scopeType/:scope" element={<ReportProtocols/>}/>
                <Route path="/reports/crops/:bullstat" element={<ReportCrops/>}/>
                <Route path="/reports/s12" element={<ReportS12/>}/>
                {/* Ф4: С13 — БП и пътища; влиза се от таба на землището */}
                <Route path="/reports/s13/:settlement_ekatte" element={<ReportS13/>}/>
                {/* Ш4: С14 — обхватът е землище ИЛИ община (като С6). */}
                <Route path="/reports/s14/:scopeType/:scope" element={<ReportS14/>}/>
            </Routes>
        </div>
    );
};
